/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MailboxTemplateKind } from './MailboxTemplateKind';
import {
    MailboxTemplateKindFromJSON,
    MailboxTemplateKindFromJSONTyped,
    MailboxTemplateKindToJSON,
    MailboxTemplateKindToJSONTyped,
} from './MailboxTemplateKind';
import type { MailboxItemOrigin } from './MailboxItemOrigin';
import {
    MailboxItemOriginFromJSON,
    MailboxItemOriginFromJSONTyped,
    MailboxItemOriginToJSON,
    MailboxItemOriginToJSONTyped,
} from './MailboxItemOrigin';
import type { MailboxItemChannel } from './MailboxItemChannel';
import {
    MailboxItemChannelFromJSON,
    MailboxItemChannelFromJSONTyped,
    MailboxItemChannelToJSON,
    MailboxItemChannelToJSONTyped,
} from './MailboxItemChannel';
import type { MailboxTemplateContentDTO } from './MailboxTemplateContentDTO';
import {
    MailboxTemplateContentDTOFromJSON,
    MailboxTemplateContentDTOFromJSONTyped,
    MailboxTemplateContentDTOToJSON,
    MailboxTemplateContentDTOToJSONTyped,
} from './MailboxTemplateContentDTO';

/**
 * 
 * @export
 * @interface MailboxTemplateUpsertDTO
 */
export interface MailboxTemplateUpsertDTO {
    /**
     * 
     * @type {string}
     * @memberof MailboxTemplateUpsertDTO
     */
    Key: string;
    /**
     * 
     * @type {string}
     * @memberof MailboxTemplateUpsertDTO
     */
    Name: string;
    /**
     * 
     * @type {MailboxItemChannel}
     * @memberof MailboxTemplateUpsertDTO
     */
    Channel?: MailboxItemChannel;
    /**
     * 
     * @type {MailboxItemOrigin}
     * @memberof MailboxTemplateUpsertDTO
     */
    Origin?: MailboxItemOrigin;
    /**
     * 
     * @type {MailboxTemplateKind}
     * @memberof MailboxTemplateUpsertDTO
     */
    Kind?: MailboxTemplateKind;
    /**
     * 
     * @type {boolean}
     * @memberof MailboxTemplateUpsertDTO
     */
    Enabled?: boolean;
    /**
     * 
     * @type {Array<MailboxTemplateContentDTO>}
     * @memberof MailboxTemplateUpsertDTO
     */
    Contents?: Array<MailboxTemplateContentDTO> | null;
}



/**
 * Check if a given object implements the MailboxTemplateUpsertDTO interface.
 */
export function instanceOfMailboxTemplateUpsertDTO(value: object): value is MailboxTemplateUpsertDTO {
    if (!('Key' in value) || value['Key'] === undefined) return false;
    if (!('Name' in value) || value['Name'] === undefined) return false;
    return true;
}

export function MailboxTemplateUpsertDTOFromJSON(json: any): MailboxTemplateUpsertDTO {
    return MailboxTemplateUpsertDTOFromJSONTyped(json, false);
}

export function MailboxTemplateUpsertDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailboxTemplateUpsertDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'Key': json['Key'],
        'Name': json['Name'],
        'Channel': json['Channel'] == null ? undefined : MailboxItemChannelFromJSON(json['Channel']),
        'Origin': json['Origin'] == null ? undefined : MailboxItemOriginFromJSON(json['Origin']),
        'Kind': json['Kind'] == null ? undefined : MailboxTemplateKindFromJSON(json['Kind']),
        'Enabled': json['Enabled'] == null ? undefined : json['Enabled'],
        'Contents': json['Contents'] == null ? undefined : ((json['Contents'] as Array<any>).map(MailboxTemplateContentDTOFromJSON)),
    };
}

export function MailboxTemplateUpsertDTOToJSON(json: any): MailboxTemplateUpsertDTO {
    return MailboxTemplateUpsertDTOToJSONTyped(json, false);
}

export function MailboxTemplateUpsertDTOToJSONTyped(value?: MailboxTemplateUpsertDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Key': value['Key'],
        'Name': value['Name'],
        'Channel': MailboxItemChannelToJSON(value['Channel']),
        'Origin': MailboxItemOriginToJSON(value['Origin']),
        'Kind': MailboxTemplateKindToJSON(value['Kind']),
        'Enabled': value['Enabled'],
        'Contents': value['Contents'] == null ? undefined : ((value['Contents'] as Array<any>).map(MailboxTemplateContentDTOToJSON)),
    };
}

